module.exports = __webpack_public_path__ + "assets/img/mecha-detail-btn-21849492.png";